// src/components/trips/CarModal.jsx
import { Stars, T } from "../ui";

export default function CarModal({ captain, onClose }) {
  const photos = captain?.carPhotoUrls?.filter(Boolean) || [];
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.72)",
      zIndex: 9000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 20, padding: 24,
        maxWidth: 500, width: "100%",
        boxShadow: "0 24px 64px rgba(0,0,0,.4)",
        maxHeight: "90vh", overflowY: "auto",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 17 }}>🚗 {captain?.car}</h3>
          <button onClick={onClose} style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${T.border}`, background: T.surfAlt, cursor: "pointer", fontFamily: "inherit", fontWeight: 600 }}>✕</button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
          {captain?.photoUrl
            ? <img src={captain.photoUrl} alt="" style={{ width: 50, height: 50, borderRadius: "50%", objectFit: "cover" }} />
            : <div style={{ width: 50, height: 50, borderRadius: "50%", background: `linear-gradient(135deg,${T.teal},#0284C7)`, display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 800, fontSize: 20 }}>{captain?.name?.charAt(0)}</div>
          }
          <div>
            <div style={{ fontWeight: 800, fontSize: 16 }}>{captain?.name}</div>
            <div style={{ fontSize: 13, color: T.muted }}>{captain?.plate}</div>
            <Stars rating={captain?.rating || 0} size={14} />
            <span style={{ fontSize: 12, color: T.muted, marginRight: 4 }}>({captain?.ratingCount || 0} تقييم)</span>
          </div>
        </div>

        {photos.length === 0 ? (
          <div style={{ textAlign: "center", padding: "28px 0", color: T.muted }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🚗</div>
            <p>لم يرفع الكابتن صور السيارة</p>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: photos.length === 1 ? "1fr" : "1fr 1fr", gap: 10, marginBottom: 14 }}>
            {photos.map((url, i) => (
              <a key={i} href={url} target="_blank" rel="noreferrer">
                <img src={url} alt={`car-${i}`} style={{ width: "100%", borderRadius: 12, objectFit: "cover", height: 150, display: "block", background: T.surfAlt }} />
              </a>
            ))}
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
          {[["🏁", captain?.trips || 0, "رحلة"], ["⭐", Number(captain?.rating || 0).toFixed(1), "تقييم"], ["💬", captain?.ratingCount || 0, "مراجعة"]].map(([ic, v, l], i) => (
            <div key={i} style={{ background: T.surfAlt, borderRadius: 10, padding: "10px 8px", textAlign: "center" }}>
              <div style={{ fontSize: 20 }}>{ic}</div>
              <div style={{ fontWeight: 800, fontSize: 16, color: T.accent }}>{v}</div>
              <div style={{ fontSize: 11, color: T.muted }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
